import React, { useEffect, useState } from "react";

import DatePicker from "react-datepicker";

import DateUtil from "../../common/dateUtil";
import CheckboxList from "../common/controls/CheckboxList";
import * as att from "../../common/attestationStatus";

const states = [
  {
    name: "reqState_Unopened",
    key: att.UnopenedStatus,
    label: "Pending",
    checked: true,
  },
  {
    name: "reqState_Reviewing",
    key: att.ReviewingStatus,
    label: "In Progress",
    checked: true,
  },
  {
    name: "reqState_Completed",
    key: att.CompletedStatus,
    label: "Submitted",
    checked: true,
  },
  {
    name: "reqState_Reviewed",
    key: att.ReviewedStatus,
    label: "Reviewed",
    checked: true,
  },
  {
    name: "reqState_Withdrawn",
    key: att.WithdrawnStatus,
    label: "Withdrawn",
    checked: true,
  }
]

let initFromDate = new Date();
initFromDate.setDate(initFromDate.getDate() - 90);
const initFormData = {
    title: "",
    fromDate: initFromDate,
    toDate: new Date(),
    initialized: true
};

const AttestationSearchCriteria = (props)=> {

      const [validation, setValidation] = useState({
        reqStatus: true,
      });

      useEffect(() => {
        if (!props.formData.initialized) {
          props.setFormData(initFormData);
        }
        if (props.reqStates.length === 0) {
          props.setReqStates(states);
        }
      });

    const handleChange = (e) => {
        props.setFormData({...props.formData, [e.target.name]: e.target.value});
    
    };

    const handleReqStateChange = (e) => {
        const itemName = e.target.name;
        const isChecked = e.target.checked;
        props.setReqStates((p) => {
        return p.map((item) => {
            return item.name === itemName ? { ...item, checked: isChecked } : item;
        });
        });
    };


    const handleDateChange = (date,field)=>{
        props.setFormData({...props.formData,[field]: date });
    }


    const geCheckedStr = (obj) => {
        const selected = obj.filter((p) => {
          return p.checked === true;
        });
    
        const ta = selected.map((p) => {
          return p.key;
        });
    
        return ta.join();
      };

    const validateForm = (strStatus) => {
        const valid = strStatus ? true : false;
        setValidation({
        ...validation,
        reqStatus: strStatus ? true : false,
        });
        console.log(validation);
        return valid;
    };


    const handleSearchClick = () => {
        const statesStr = geCheckedStr(props.reqStates);
    
        if (!validateForm(statesStr)) {
          return;
        }
    
        let fromDate = DateUtil.toIsoStrDate(props.formData.fromDate);
        let toDate = DateUtil.toIsoStrDate(props.formData.toDate);
    
        let jsonData = {
          ...props.formData,
          reqStatus: statesStr,
          fromDate: fromDate,
          toDate: toDate,
        };
        props.onSearch(jsonData);
      };


    return (
        <div className="form">
        <div className="form-header">
            <div className="form-header-label">Filter & Display</div>
        </div>
        
        <div className="form-body">
            <div className="form-items">

                <div className="form-columns">
                    
                    <div className="form-column"> 
                        <div className="form-item">
                            <label className="form-item-label" htmlFor="title">Attestation Title:</label>
                            <input className="form-item-value" type="text" id="title" name="title" value={props.formData.title} onChange={handleChange}/>
                        </div>
                    </div>

                    <div className="form-column"> 
                        
                        <div className="form-item">
                            <label className={`form-item-label required ${validation.reqStatus ? "" : "warning"}`}>Attestation Status:</label>
                            <div className="form-item-value label-group flex-6">
                                <CheckboxList items={props.reqStates} handleChange={handleReqStateChange}/>
                            </div>
                        </div>

                        <div className="form-item splitted">
                            <div className="flex flex-1 mr-3">
                                <label className="form-item-label-short">From Date:</label>
                                <div className="form-item-value-short">
                                    <DatePicker selected={props.formData.fromDate} onChange={p=>handleDateChange(p,"fromDate")}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"/>
                                </div>
                            </div>

                            <div className="flex flex-1">
                                <label className="form-item-label-short">To Date:</label>
                                <div className="form-item-value-short">
                                    <DatePicker selected={props.formData.toDate} onChange={p=>handleDateChange(p,"toDate")}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
            </div>
        </div>

        <div className="form-footer">
            {validation.reqStatus ? (
            <div className="form-status"></div>
            ) : (
                <div className="form-status error">Enter Required Information</div>
            )}

            <div className="btn-group">
            <button
                id="btnLoadProductDetail"
                type="button"
                className="btn btn-primary"
                onClick={handleSearchClick}
            >
                Search
            </button>
            </div>
      </div>


    </div>
    )
}

export default AttestationSearchCriteria
